import useAuth from './useAuth';
import {useGetUserAddresses} from './useUserAddress';

export type ProfileFieldStatus = {
  has_value: boolean;
};

export type ProfileFieldsStatus = {
  home_address: ProfileFieldStatus;
  handle: ProfileFieldStatus;
  profile_photo: ProfileFieldStatus;
  allRequiredComplete: boolean;
  isLoading: boolean;
};

/**
 * Checks actual profile field values to determine which fields are populated.
 * Uses existing auth user data and address queries — no new API endpoint needed.
 *
 * "Required" fields: home_address + handle.
 * Profile photo is optional.
 */
export const useProfileFieldsStatus = (): ProfileFieldsStatus => {
  const {user} = useAuth();
  const {userAddresses, userAddressesLoading} = useGetUserAddresses({
    userId: user?.id,
    addressType: 'HOME',
  });

  const hasAddress = (userAddresses?.length ?? 0) > 0;
  const hasHandle = !!user?.handle && user.handle.length > 0;
  const hasProfilePhoto = !!user?.profilePhotoUrl;

  return {
    home_address: {has_value: hasAddress},
    handle: {has_value: hasHandle},
    profile_photo: {has_value: hasProfilePhoto},
    allRequiredComplete: hasAddress && hasHandle,
    isLoading: userAddressesLoading,
  };
};

export default useProfileFieldsStatus;
